module.exports = __webpack_public_path__ + "img/foc_03.c320f545.png";